import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { addUnitApi } from '../../api/endpoints';

// Initial state
const initialState = {
  status: '', // loading, success, error
  data: null,
  message: '',
};

// Async thunks for CREATE operations
export const addUnit = createAsyncThunk('addUnit', async (payload) => {
  return await addUnitApi(payload);
});

const addUnitSlice = createSlice({
  name: 'addUnit', // Unique Name
  initialState,
  reducers: {
    addUnitReset: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(addUnit.pending, (state) => {
        state.status = 'loading';
        state.data = {};
      })
      .addCase(addUnit.fulfilled, (state, action) => {
        const { message = '', data = {}, payload = null } = action.payload;
        state.status = 'success';
        state.message = message;
        state.data = data || payload;
      })
      .addCase(addUnit.rejected, (state, action) => {
        const { message } = action.error || {};
        state.status = 'error';
        state.message = message;
      });
  },
});
export const { addUnitReset } = addUnitSlice.actions;

export default addUnitSlice.reducer;
